import { Wrapper, StyledSpiner } from "./styled";

export const Loading = () => (
  <Wrapper>
    <StyledSpiner />
  </Wrapper>
);
